<div class="imc--alerta">

  <h2 mat-dialog-title [ngClass]="{
    warning: data.tipo === 'warning',
    error: data.tipo === 'error' || data.tipo === 'logout',
    success: data.tipo === 'success',
    confirm: data.tipo === 'confirm'
  }">
    {{data.titulo}}
  </h2>

  <div>
    <mat-dialog-content [ngClass]="{
      warning: data.tipo === 'warning',
      error: data.tipo === 'error' || data.tipo === 'logout',
      success: data.tipo === 'success',
      confirm: data.tipo === 'confirm'
    }">

      <p *ngIf="!data.multiple; else elseBlock">{{data.mensaje}}</p>

      <ng-template #elseBlock>
        <ul>
          <li *ngFor="let item of data.mensaje" style="margin-top:10px">{{item}}</li>
        </ul>
      </ng-template>

    </mat-dialog-content>
  
    <mat-dialog-actions [ngClass]="{
      warning: data.tipo === 'warning',
      error: data.tipo === 'error' || data.tipo === 'logout',
      success: data.tipo === 'success',
      confirm: data.tipo === 'confirm'
    }" fxLayout="column" fxLayoutAlign="end center">
      <div *ngIf="data.tipo === 'confirm' || data.tipo === 'logout'">
        <button mat-button *ngIf="data.txtReject==null" (click)="accionReject()">{{ "CANCEL" | translate }}</button>
        <button mat-button *ngIf="data.txtSuccess==null" (click)="accionSuccess()" class="imc--bt-accepta">{{ "ACCEPT" |
          translate }}</button>
  
        <button mat-button *ngIf="data.txtReject!=null" (click)="accionReject()">{{ data.txtReject }}</button>
        <button mat-button *ngIf="data.txtSuccess!=null" (click)="accionSuccess()" class="imc--bt-accepta">{{
          data.txtSuccess }}</button>
      </div>
      <div *ngIf="data.tipo !== 'confirm' && data.tipo !== 'logout'" class="i3tel-w--100 i3tel-d--flex i3tel-j--center i3tel-a--center">
        <button (click)="accionSuccess()"
          class="i3tel-button-icon normal_size imc--bt-accepta">{{ "ACCEPT" | translate }}</button>
      </div>
    </mat-dialog-actions>
  </div>

</div>